import { render, staticRenderFns } from "./LinkEditor.vue?vue&type=template&id=d67c3a1c"
import script from "./LinkEditor.vue?vue&type=script&lang=js"
export * from "./LinkEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports